import './App.css';

import { Routes, Route } from 'react-router-dom';
import HomePage from './pages/Home';
import AboutPage from './pages/About';
import ServicesPage from './pages/Services';
import MyProjectsPage from './pages/MyProjects';
import ContactPage from './pages/Contact';
import ResumePage from './pages/Resume';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path='/' element={<HomePage />} />
        <Route path='/about' element={<AboutPage />} />
        <Route path='/services' element={<ServicesPage />} />
        <Route path='/projects' element={<MyProjectsPage />} />
        <Route path='/contact' element={<ContactPage />} />
        <Route path='/resume' element={<ResumePage />} />
      </Routes>
    </div>
  );
}

export default App;
